<template>
  <div id="admission-list">
    <div v-for="ticket_type in ticket_types" :key="ticket_type.id">
      <admisiion-ticket-type-list 
        :ticket_type = ticket_type 
        :program_id = program_id 
        :admission_accept_path = admission_accept_path 
        :admission_unaccept_path = admission_unaccept_path 
        :can_action_cable = can_action_cable 
        :use_introducer_tell = use_introducer_tell 
        :use_introducer_name = use_introducer_name 
        :use_introducer_adress = use_introducer_adress 
        :event_questionnaires = event_questionnaires 
        :is_giants_user = is_giants_user
        :is_assistant_page = is_assistant_page
      >
      </admisiion-ticket-type-list>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    program_id: { type: Number, required: true },
    t: { type: String, required: true },
    ticket_types: { type: Array, required: true },
    can_action_cable: { type: Boolean, required: true },
    get_audiences_path: { type: String, required: true },
    admission_accept_path: { type: String, required: true },
    admission_unaccept_path: { type: String, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    is_giants_user: { type: Boolean, required: true },
    is_assistant_page: { type: Boolean, required: true, default: false },
  },
  data() {
    return {
      room: -1,
    }
  },
  created(){
    try{
      // audiences取得
      this.$store.dispatch('audience/getAudiences', {api_path: this.get_audiences_path, t: this.t})
    } catch (e){
      alert(e.message)
    }
    try{
      // actioncableの使用可否
      if (this.can_action_cable) {
        // actioncable設定
        this.messageChannel = App.cable.subscriptions.create(
          {
            channel: 'RoomChannel',
            room: "P" + this.program_id
          },
          {
            // サーバに接続
            connected: () => {
              this.$store.commit('actioncable/setConnectedOk')
            },
            // サーバから切断
            disconnected: () => {
              this.$store.commit('actioncable/setConnectedNg')
              this.messageChannel.unsubscribe()
              clearActioncableConnection()
              modifyBgColorNonConnected()
            },
            // サーバからbroadcastがあった
            received: (data) => {
              this.$store.commit('actioncable/setConnectedOk')
              this.$store.commit('audience/setAudienceForce', data.data.data)
              this.$store.commit('audience/setTicketTypeStatus', data.data.meta)
            },
            // サーバから拒否された
            rejected: () => {
              this.$store.commit('actioncable/setConnectedNg')
              this.messageChannel.unsubscribe()
              clearActioncableConnection()
              modifyBgColorNonConnected()
            },
          }
        )
      } else {
        this.$store.commit('actioncable/setConnectedNonTarget')
      }
    } catch (e){
      this.$store.commit('actioncable/setConnectedNg')
      clearActioncableConnection()
      modifyBgColorNonConnected()
    }
  },
  computed:{
  },
  methods: {
  }
}

// actioncableのconnectionクリア
function clearActioncableConnection(){
  var subscriptions = App.cable.subscriptions['subscriptions']
  subscriptions.forEach(function (subscription) {
    App.cable.subscriptions.remove(subscription)
  });
  WebSocket = null
}

// 背景色変更(同期解除)
function modifyBgColorNonConnected(){
  var content = document.getElementById("content")
  content.style.backgroundColor = '#edebeb'
}

</script>


<style scoped>

</style>
